import {
  useTrackFeature,
  useTrackFeatureInViewImpression,
  useTrackOriginClick,
} from '@aboutyou/tracking';
import {useCallback} from 'react';

const FEATURE_TRACKING_LABEL = 'fashion_update';

export const useFashionUpdaterTracking = () => {
  const trackFeature = useTrackFeature();

  const {ref} = useTrackFeatureInViewImpression<HTMLDivElement>({
    label: FEATURE_TRACKING_LABEL,
  });

  const trackOriginClick = useTrackOriginClick()('fashion_update_reco');

  const trackOnClick = useCallback(() => {
    trackFeature({
      label: FEATURE_TRACKING_LABEL,
      eventType: 'click',
    });
    trackOriginClick();
  }, []);

  return {
    trackOnClick,
    fashionUpdateTrackingRef: ref,
  };
};
